// @flow
import * as React from 'react';
import compose from 'recompose/compose';
import { useTranslation } from 'react-i18next';

import withToggle from 'app/common/containers/withToggle';
import Indicator from 'app/components/Subs/Indicator';
import LinkButton from 'app/components/Tariff/LinkButton';
import PriceDiscounted, { priceTypes } from 'app/components/Tariff/PriceDiscounted';

import type { MonthDailyPeriod } from '../Tariff';
import enhancePeriods from './enhancePeriods';
import styles from './Periods.scss';


const enhance = compose(
  enhancePeriods,
  withToggle()
);

type Props = {
  subId: number,
  isOpen: boolean,
  periods: Array<MonthDailyPeriod>,
  handleToggle: (e: SyntheticEvent<HTMLElement>) => void,
  header?: string,
  isFree: boolean,
  studentId: number,
  tariffId?: number,
  tariffBundleId?: number,
  isSms?: boolean,
}

const PeriodsPaid = ({
  subId,
  isOpen,
  periods,
  handleToggle,
  header,
  isFree,
  studentId,
  tariffId,
  tariffBundleId,
  isSms,
}: Props) => {
  const { t } = useTranslation('tariff');

  return (
    <div>
      {header && isOpen && <div>{header}</div>}
      <div className={styles.periodsContent}>
        {isOpen
          ? <div>
            {periods.map(({ title, /* cost, */months_number: num }) =>
              <div key={title} className={styles.row}>
                <span className={styles.rowTitle}>{title}</span>
                {/* <span className={styles.rowCost}>{cost}</span> */}
                <PriceDiscounted
                  className={styles.cost}
                  studentId={studentId}
                  tariffId={tariffId}
                  tariffBundleId={tariffBundleId}
                  priceType={isSms ? priceTypes.price_sms_on_months : priceTypes.price_base_on_months}
                  monthsNumber={num}
                />
              </div>)}
          </div>
          : <div className={styles.indicator}>
            <Indicator subId={subId} showCircle />
          </div>}
        {!isFree
          && <div className={styles.buttons}>
            <LinkButton
              primary={!isOpen}
              onClick={handleToggle}
              name="showPacks"
            >
              {isOpen ? t('back_link') : t('available_subscriptions_link')}
            </LinkButton>
          </div>}
      </div>
    </div>
  );
};

export default enhance(PeriodsPaid);
